import { render } from "./UploadFile.vue?vue&type=template&id=766f9a07&ts=true"
import script from "./UploadFile.vue?vue&type=script&lang=ts"
export * from "./UploadFile.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__